import useIsMdAndUp from '../../../hooks/useIsMdAndUp';
export const useIsInToolMenu = (props)=>{
    return !useIsMdAndUp() && props['data-hide'];
};
